// Utility functions for text manipulation
export const stripHtml = (html: string): string => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const truncateText = (text: string, limit: number = 150): string => {
  const cleanText = stripHtml(text).trim();
  if (cleanText.length <= limit) return cleanText;
  return cleanText.substring(0, limit).trim() + '...';
};